// import { Component, OnInit } from '@angular/core';
// import { MarketplaceService } from '@fgb/core';
// import { firstValueFrom } from 'rxjs';
// import { Populations } from 'src/app/shared/utilities/populations';

// @Component({
//   selector: 'fgb-marketplace-page',
//   templateUrl: './marketplace-page.component.html',
//   styleUrls: ['./marketplace-page.component.scss'],
// })
// export class MarketplacePageComponent implements OnInit {
//   populations = Populations;
//   constructor(private marketplaceService: MarketplaceService) {}

//   ngOnInit() {
//     firstValueFrom(this.marketplaceService.fetchMarketplaceItems());
//   }
// }

import { Component, inject, OnInit } from '@angular/core';
import { MarketplaceFacade } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-marketplace-page',
  templateUrl: './marketplace-page.component.html',
  styleUrls: ['./marketplace-page.component.scss'],
})
export class MarketplacePageComponent implements OnInit {
  populations = Populations;
  private marketplaceFacade = inject(MarketplaceFacade);

  ngOnInit() {
    this.marketplaceFacade.fetchMarketplaceItems();
  }
}
